// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__fITRT","signatureBlock":"Footer_signatureBlock__34wSR","signature":"Footer_signature__gK_At"};